module.exports = __webpack_public_path__ + "img/art.49971a00.png";